var map = {
	"./1893.png": "ddf6",
	"./1923.png": "9f07",
	"./1975.png": "c7b7",
	"./2020.png": "a325",
	"./background.png": "4e9a",
	"./initial1893.png": "99fa",
	"./initial1923.png": "dd30",
	"./initial1975.png": "ff0f",
	"./initial2020.png": "d657",
	"./starting.png": "69ba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fa71";